import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { useTranslation } from "react-i18next";

import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import Grid from "@mui/material/Grid";
import DateTimePicker from '@mui/lab/DateTimePicker';
import Dropzone from 'react-dropzone';
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import BlockIcon from "@mui/icons-material/Block";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import MessageBox from "../util/messageBox";
import { ListboxComponent } from "../pages/holding/penItemUtil";
import LinearProgress from '@mui/material/LinearProgress';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { docTypes, loadDicts, specialties } from "../store/reducers/dicts";

import { v4 as uuidv4 } from 'uuid';
import axios from "axios";

import config from "../app/config";
import clsx from "clsx";
import _ from "lodash";
import moment from "moment";
import API from '../app/api';
import FormControl from '@mui/material/FormControl';
import {InputLabel, MenuItem, Select} from '@mui/material';
import ListSubheader from '@mui/material/ListSubheader';
import {getSelectedDocuments} from '../store/reducers/documents';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    uploadZone: {
        cursor: "pointer",
        marginBottom: 20,
        padding: "20px 15px 20px",
        border: "1px solid #777",
        lineHeight: "50px",
    },
    backdrop: {
        width: "100%",
        height: "100%",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: theme.zIndex.drawer + 2,
    },
    menuPaper: {
        maxHeight: 300
    }
}));

export const CustomAutocomplete = withStyles((theme) => ({
    input: {
        color: theme.palette.tb.color.main,
        fontSize: "90%",
        fontWeight: 300,
        padding: "7px !important",
    },
    listbox: {
        fontSize: "90%",
        fontWeight: 300,
    },
}))(Autocomplete);

const BoldLinearProgress = withStyles((theme) => ({
    root: {
        height: 5,
        // borderRadius: 5,
    },
}))(LinearProgress);

function UploadIMAGE(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const authObject = window.keycloak ? window.keycloak : window.auth;
    const [documentDate, setDocumentDate] = React.useState(null);
    const [technicianName, setTechnicianName] = React.useState("");
    const [documentType, setDocumentType] = React.useState(null);
    const [location, setLocation] = React.useState("Web");
    const [studyId, setStudyId] = React.useState("");
    const [studyIdDisabled, setStudyIdDisabled] = React.useState(false);
    const [laterality, setLaterality] = React.useState("");
    const [fileToUpload, setFileToUpload] = React.useState(null);
    const [fileTypeUnsupportedInfoShow, setFileTypeUnsupportedInfoShow] = React.useState(false);

    const [message, setMessage] = React.useState(null);
    const [messageTitle, setMessageTitle] = React.useState(null);
    const [messageProcedure, setMessageProcedure] = React.useState(null);
    const [locationDict, setLocationDict] = useState(null);

    const [savingBarVisible, setSavingBarVisible] = useState(false);

    const [user, setUser] = React.useState(null);

    const selectedDocumentsFromPatient = useSelector(getSelectedDocuments);

    useEffect(() => {
        if(selectedDocumentsFromPatient && selectedDocumentsFromPatient.length === 1 && selectedDocumentsFromPatient[0].__isStudy) {
            setStudyId(selectedDocumentsFromPatient[0].study);

            let type = docTypesDict.find((el) => el.name === selectedDocumentsFromPatient[0].__typeString);
            if(type) setDocumentType(type);
            else setDocumentType(null);

            let location = selectedDocumentsFromPatient[0].__location;
            if (location) setLocation(location);
            else setLocation('Web');

            let startDate = selectedDocumentsFromPatient[0].startDate;
            if (startDate) {
                if(!moment.isMoment(startDate)) startDate = moment(startDate);
                setDocumentDate(startDate);
            }
            else setDocumentDate(null);

            setStudyIdDisabled(true);
        } else {
            clearData();
            setStudyIdDisabled(false);
        }
        if(!props.open) {
            clearData();
        }
    },[selectedDocumentsFromPatient, props.open])

    // useEffect(() => {
    //     if (props.studyId) {
    //         setStudyId(props.studyId);
    //         setStudyIdDisabled(true);
    //     } else {
    //         setStudyIdDisabled(false);
    //     }
    // }, [props.studyId, props.open])


    useEffect(() => {
        if((!user || !technicianName) && props.open) {
            authObject.loadUserInfo().then(value => {
                setUser(value);
                setTechnicianName(value.name);
            });
        }
    },[props.open]);


    useEffect(()=>{
        API.getLocationsDict().then(response => {
            if(response.__data) {
                let t  = response.__data.filter((item) => item.hasOwnProperty("parentLocation"))
                const result = Object.groupBy(t, (item) => item.parentLocation);
                setLocationDict(result)
            }

        });
    },[])

    const clearData = () => {
        setDocumentDate(null);
        setTechnicianName("");
        setDocumentType(null);
        setLocation("Web");
        setStudyId("");
        setLaterality("");
        setFileToUpload(null);
        setFileTypeUnsupportedInfoShow(false);
    }
    // const specialtiesDict = useSelector(specialties);
    const docTypesDict = useSelector(docTypes);
    useEffect(() => {
        if (!docTypesDict) {
            // FIXME: That should be handled in some other way - we do not want this to happen
            // in agyle however it may and will be necessary !!!!
            dispatch(loadDicts);
        }
    },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [docTypesDict]);

    const handleUpload = () => {
        let errorText = "";

        const appendErrorText = text => {
            errorText += `<div>${text}</div>`
        };
        if (!documentDate) {
            appendErrorText(t("Document date is required."));
        }
        if (documentDate){
            if(moment.isMoment(documentDate)){
                if (!documentDate.isValid()) appendErrorText(t("Document date is invalid."));
            } else {
                appendErrorText("Document date not in proper format");
            }
        }
        if (!technicianName) {
            appendErrorText(t("Technician name is required."));
        }
        if (!documentType) {
            appendErrorText(t("Document type is required."));
        }
        if (!location) {
            appendErrorText(t("Location is required."));
        }
        if (!fileToUpload) {
            appendErrorText(t("You need to select or drop a file."));
        }

        if (errorText.length > 0) {
            setMessageTitle(t("Required fields"));
            setMessage(errorText);
        } else {
            setSavingBarVisible(true);

            const documentUUID = uuidv4();
            let studyIdFinal = studyId;
            // generate study id when no study selected !
            if (!studyId && !studyIdDisabled) {
                studyIdFinal = documentUUID;
            }

            let documentDateFinal = moment(documentDate);
            const data = {
                "path": `/${props.patientId}`,
                "type": "document",

                // TODO:
                // FIXME: generate unique ???
                // "externalUniqueId": "TEST_EL_DD1",
                "externalUniqueId": `${documentUUID}.internal`,

                "date": documentDateFinal.toISOString(),
                "metadata": {
                    "docType": documentType.name,
                    "study": studyIdFinal,
                    "uploaded": true,
                    "operatorName": technicianName,
                    "location": location,
                    "laterality": laterality === "" ? null : laterality,
                    "patientId": props.patientId
                }
            };

            const imageSaveFormData = new FormData();
            imageSaveFormData.append('metadata', JSON.stringify(data));
            imageSaveFormData.append('file', fileToUpload);

            // setSavingBarVisible(false);

            axios({
                method: "post",
                url: config.imageUploadURL,
                data: imageSaveFormData,
                headers: {
                    "Authorization": `Bearer ${authObject.token}`,
                    "Content-Type": "multipart/form-data"
                },
            })
                .then(function (response) {
                    setSavingBarVisible(false);

                    setMessageTitle(t("Success !"))
                    setMessage(t("Document uploaded. Thank you."));

                    setMessageProcedure(true);

                    // clear all
                    setDocumentDate(null);
                    setTechnicianName("");
                    setDocumentType(null);
                    setLocation("Web");
                    setStudyId("");
                    setLaterality("");
                    setFileToUpload(null);
                })
                .catch(function (response) {
                    // handle error
                    console.error(response);

                    setSavingBarVisible(false);

                    setMessageTitle(t("Document upload error !"))
                    setMessage(t("Document not uploaded. Try again later."));
                });
        }
    };

    const handleClose = () => {
        if (props.onUploadCancel) {
            props.onUploadCancel();
        }
    };

    const removeFile = (e) => {
        e.stopPropagation();
        setFileToUpload(null);
        setDocumentDate(null);
    };

    const changeFile = (fileData, filesRejected, event) => {
        setFileTypeUnsupportedInfoShow(false);
        if (fileData && fileData.length > 0) {
            setFileToUpload(fileData[0]);
            if (!studyIdDisabled) setDocumentDate(moment(fileData[0].lastModifiedDate));
        } else {
            if(filesRejected && filesRejected.length > 0){
                setFileTypeUnsupportedInfoShow(true);
            }
            setFileToUpload(null);
            if (!studyId) setDocumentDate(null);
        }
    }

    const changeDocumentDate = (newValue) => {
        if(newValue) {
            if (!moment.isMoment(newValue)) setDocumentDate(moment(newValue))
            else setDocumentDate(newValue)
        }
    };
    const changeOperatorName = (event) => {
        setTechnicianName(event.target.value);
    };
    const changeDocType = (event, newValue) => {
        // console.log("setDocumentType", newValue.name, newValue);
        setDocumentType(newValue);
    };
    const changeLocation = (event) => {
        setLocation(event.target.value);
    };
    const changeStudyId = (event) => {
        setStudyId(event.target.value);
    };
    const changeLaterality = (event) => {
        setLaterality(event.target.value);
    };

    return (
        <Dialog onClose={handleClose} fullWidth={true}
            maxWidth={'md'} open={props.open}>
            <DialogTitle>{t("Upload new document")}</DialogTitle>
            <DialogContent>
                <div>
                    {/* {savingBarVisible &&
                        <div className="image-progress">
                            <BoldLinearProgress color={"primary"} />
                        </div>
                    } */}
                    <Backdrop className={classes.backdrop} open={savingBarVisible}>
                        <CircularProgress color="inherit" size={64} />
                    </Backdrop>
                    <MessageBox onClose={() => {
                        setMessage(null);
                        if (messageProcedure) {
                            if (props.onUploadFinished) {
                                props.onUploadFinished();
                            }
                        }
                        setMessageProcedure(null);
                    }} title={messageTitle} message={message} open={!!message} />
                    <Dropzone onDrop={changeFile} multiple={false} accept={config.hasOwnProperty("uploadAcceptFileTypes") ? config.uploadAcceptFileTypes : null}>
                        {({ getRootProps, getInputProps }) => (<section>
                                <div {...getRootProps()}>
                                    <input {...getInputProps()}/>
                                    <div className={classes.uploadZone}>
                                        {/* <div>
                                            {fileToUpload ? fileToUpload.name : ""}
                                        </div> */}

                                        {!fileToUpload &&
                                            t("Drag 'n' drop file here, or click to select file")}
                                        {!fileToUpload && config.hasOwnProperty("uploadAcceptFileTypes") &&
                                            <span>&nbsp;&nbsp;(&nbsp;{config.uploadAcceptFileTypes} )</span>
                                        }
                                        {fileTypeUnsupportedInfoShow &&
                                            <span style={{color : "red", fontWeight: 600}}>&nbsp;&nbsp;{t("Unsupported file type")}</span>
                                        }

                                        {fileToUpload &&
                                            <Grid container>
                                                <Grid item xs={6}><strong>{fileToUpload.name}</strong></Grid>
                                                <Grid item xs={4}>{(fileToUpload.type && fileToUpload.type.length > 0) ? fileToUpload.type : t("unknown type")}</Grid>
                                                <Grid item xs={2}>
                                                    <Tooltip title={t("Remove document")}>
                                                        <div style={{ textAlign: "right" }} onClick={removeFile}>
                                                            <IconButton color={"secondary"} size="large">
                                                                <BlockIcon />
                                                            </IconButton>
                                                        </div>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        }
                                    </div>
                                </div>
                            </section>)
                        }
                    </Dropzone>

                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <div className={classes.formItem}>
                                <DateTimePicker
                                    // className={classes.formControlDT}
                                    invalidDateMessage={null}
                                    autoOk
                                    clearable={true}
                                    disableToolbar
                                    format={config.defaultDateTimeFormat}
                                    ampm={false}
                                    margin="normal"
                                    label={t("Document date")}
                                    emptyLabel={t("no date selected")}
                                    value={documentDate}
                                    onChange={changeDocumentDate}
                                    inputVariant="outlined"
                                    inputFormat={config.defaultDateTimeFormat}
                                    renderInput={(inp) => <TextField style={{ width: "100%", margin: 0 }} className={"custom-dt"} {...inp} size="small"/>}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={4}>
                            <div className={classes.formItem}>
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size="small"
                                    variant="outlined"
                                    className={"custom-dt"}
                                    // placeholder={t("enter technician name")}
                                    disabled={true}
                                    style={{ width: "100%" }} label={t("Uploaded by")}
                                    onChange={changeOperatorName}
                                    value={technicianName} />
                            </div>
                        </Grid>
                        <Grid item xs={4}>
                            <div className={classes.formItem}>
                            <FormControl fullWidth >
                                <InputLabel htmlFor="grouped-native-select">Location</InputLabel>
                                <Select onChange={changeLocation}
                                        value={location}
                                        size="small"
                                        MenuProps={{ classes: { paper: classes.menuPaper } }}
                                        renderValue={(val) => val}
                                        id="grouped-native-select" label="Location">

                                    <ListSubheader>Custom</ListSubheader>
                                    <MenuItem value={"Web"}>
                                        <em>Web</em>
                                    </MenuItem>

                                    {locationDict && Object.keys(locationDict).map((key)=>{
                                        let items = [ <ListSubheader>{key}</ListSubheader>];
                                        locationDict[key].forEach((item)=>{
                                            items.push(<MenuItem value={key+" " + item.__code}>{item.__code}</MenuItem>)
                                        })

                                        return  items;
                                    })}
                                </Select>
                            </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.formItem}>
                                {docTypesDict &&
                                    <CustomAutocomplete
                                        ListboxComponent={ListboxComponent}
                                        disableListWrap
                                        // autoSelect={true}
                                        options={docTypesDict}
                                        getOptionLabel={(option) => option && option.name ? option.name : ""}
                                        style={{ width: "100%" }}
                                        value={documentType}
                                        onChange={changeDocType}
                                        getOptionSelected={(option, value) => option.__id === value.__id}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                size="small" label={t("Document type")}
                                                placeholder={t("select doctype")}
                                                variant="outlined" />}
                                    />
                                }
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className={classes.formItem}>
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size="small"
                                    variant="outlined"
                                    className={"custom-dt"}
                                    placeholder={t("enter study id")}
                                    style={{ width: "100%" }} label={t("Study id")}
                                    onChange={changeStudyId}
                                    disabled={studyIdDisabled}
                                    value={studyId} />
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className={classes.formItem} style={{ marginLeft: 20 }}>
                                <RadioGroup row name="laterality" value={laterality}
                                    onChange={changeLaterality}>
                                    <FormControlLabel
                                        value={""}
                                        control={<Radio
                                            checked={!laterality}
                                            color="secondary" />}
                                        label={t("Unset")} labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="R"
                                        control={<Radio color="primary" />}
                                        label={t("OD")} labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="L"
                                        control={<Radio color="primary" />}
                                        label={t("OS")} labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="B"
                                        control={<Radio color="primary" />}
                                        label={t("OU")} labelPlacement="end"
                                    />
                                </RadioGroup>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleClose}>
                    {t("Cancel")}
                </Button>
                <Button onClick={handleUpload} color="primary">
                    {t("Upload")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UploadIMAGE;
